<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @removeTab="removeTab(item.name)" :minor="53"></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * 罗志远
 * 会议发布管理页面
 */
import HyRelease from '../../../../../static/form/xsyz/HyRelease.vue'
import Hyfblb from '../../assembly/xsyz/Hyfblb.vue'
import ComboBox from '../../assembly/ComboBox.vue'
import Classification from '../../assembly/Classification.vue'
import {mapState} from 'vuex'
export default {
  components: {
    HyRelease,
    Hyfblb,
    ComboBox,
    Classification
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [{
        title: '会议发布列表',
        name: '1',
        closable: false,
        ref: 'child',
        content: Hyfblb
      },
      {
        title: '分类管理列表',
        name: '2',
        closable: false,
        content: Classification
      }],
      addobj: {
        title: '添加会议发布',
        name: '3',
        closable: true,
        content: 'HyRelease'
      }
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/xsyzgl/Hyfbgl.vue